var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center justify-content-center",staticStyle:{"height":"100vh"}},[_c('div',[_c('h2',[_vm._v("500")])])])}]

export { render, staticRenderFns }